import { createSlice } from "@reduxjs/toolkit";

const manageFarmerSlice = createSlice({
  name: "manage_farmer_slice",
  initialState: {
    filter: {
      statusFilterList: {
        accepted: false,
        rejected: false,
        pending: false,
      },
      regionFilterList: {
        state: [],
        district: [],
        block: [],
      },
      agentFilterList: [],
    },
    farmer: {
      farmerId: 0,
      farmerName: "",
      active: {
        allFarm: true,
        acceptedFarm: false,
        rejectedFarm: false,
      },
    },
  },

  reducers: {
    updateFilter: (state, action) => {
      const { statusFilterList, regionFilterList, agentFilterList } =
        action.payload.data;
      state.filter.statusFilterList = statusFilterList;
      state.filter.regionFilterList = regionFilterList;
      state.filter.agentFilterList = agentFilterList;
    },
    updateStatusFilterList: (state, action) => {
      if (action.payload.type === "accepted") {
        state.filter.statusFilterList = {
          accepted: action.payload.data,
          rejected: false,
          pending: false,
        };
      } else if (action.payload.type === "rejected") {
        state.filter.statusFilterList = {
          accepted: false,
          rejected: action.payload.data,
          pending: false,
        };
      } else {
        state.filter.statusFilterList = {
          accepted: false,
          rejected: false,
          pending: action.payload.data,
        };
      }
    },
    resetStatusFilterList: (state) => {
      state.filter.statusFilterList = {
        accepted: false,
        rejected: false,
        pending: false,
      };
    },
    resetRegionFilterList: (state) => {
      state.filter.regionFilterList = {
        state: [],
        district: [],
        block: [],
      };
    },
    resetFilter: (state) => {
      state.filter = {
        statusFilterList: {
          accepted: false,
          rejected: false,
          pending: false,
        },
        regionFilterList: {
          state: [],
          district: [],
          block: [],
        },
        agentFilterList: [],
      };
    },

    updateAgentFilterList: (state, action) => {
      state.filter.agentFilterList = action.payload.data;
    },
    updateActiveFarmer: (state, action) => {
      state.farmer.farmerName = action.payload.farmerName;
      state.farmer.farmerId = action.payload.farmerId;
    },
    updateActiveFarmStatus: (state, action) => {
      state.farmer.active.acceptedFarm = action.payload.acceptedFarm;
      state.farmer.active.allFarm = action.payload.allFarm;
      state.farmer.active.rejectedFarm = action.payload.rejectedFarm;
    },
  },
});

export const {
  updateStatusFilterList,
  updateAgentFilterList,
  updateFilter,
  resetStatusFilterList,
  resetRegionFilterList,
  resetFilter,
  updateActiveFarmer,
  updateActiveFarmStatus,
} = manageFarmerSlice.actions;
export default manageFarmerSlice.reducer;
